import { CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAvailableTractor extends Layout {
    citystateLoadTo: CityState;
    citystateLocation: CityState;
    panelLeft: Panel;
    panelRight: Panel;
    sourceAvailTractDetail: DataSource;
    textboxAvailableDate: Textbox;
    textboxCarrierEmail: Textbox;
    textboxCarrierId: Textbox;
    textboxCarrierPhone: Textbox;
    textboxComments: Textbox;
    textboxContact: Textbox;
    textboxDateEntered: Textbox;
    textboxDistanceRadius: Textbox;
    textboxEnteredBy: Textbox;
    textboxEquipmentTypeId: Textbox;
    textboxExpiresDate: Textbox;
    textboxId: Textbox;
    textboxStatus: Textbox;
    textboxTractorId: Textbox;
}
